import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { USER_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledCalendarField } from '../../../../../../components/ControlledCalendarField/ControlledCalendarField';
import { FieldLabel } from '../../../../../../components/Form';

const CalendarCreatedAtField = ({
  name = USER_FILTER_FIELD_NAMES.CREATED_AT,
  onClear,
}) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage
          id="Creation date from-to"
          defaultMessage="Creation date from-to"
        />
      </FieldLabel>
      <ControlledCalendarField
        name={name}
        onClear={onClear}
        enableTime={false}
        showMonths={2}
        range
      />
    </>
  );
};

export default CalendarCreatedAtField;
